import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { RuleSearchesFormData } from "../../state/SearchManager/RuleSearchesFormData";

const updateRuleSearchesForm: Reducer<RuleSearchesFormData> = (state: RuleSearchesFormData = new RuleSearchesFormData(), action: Action<ActionType, RuleSearchesFormData>) => {
  switch (action.type) {
    case ActionType.SEARCH_MANAGER_RULE_SEARCHES_FORM_UPDATED:
      return { ...state, ...action.data };
    case ActionType.SEARCH_MANAGER_RULE_SEARCHES_FORM_RESET:
      const newState = new RuleSearchesFormData();
      return newState;
    default:
      return state;
  }
};

export default updateRuleSearchesForm;